const normalizePlate = value => String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export function filterQueueRows(rows, selectedBay, vehicleSearch) {
	const search = normalizePlate(vehicleSearch);
	return rows.map((row, index) => ({ row, order: index + 1 })).filter(({ row }) => {
		const reservedBay = row.allocation?.checkpointId;
		const matchesBay = selectedBay === "all" || (selectedBay === "unreserved"
			? !reservedBay : String(reservedBay) === selectedBay);
		return matchesBay && (!search || normalizePlate(row.vehicleNumber).includes(search));
	});
}
